/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ variant: NonNullable<unknown>, plan: NonNullable<unknown> }} Report_Line_StorageInputs */



/**
* | output |
* | --- |
* | "Storage {variant} ({plan})" |
*
* @param {Report_Line_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_line_storage = /** @type {((inputs: Report_Line_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Line_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher ${i?.variant} (${i?.plan})`)
	return /** @type {LocalizedString} */ (`Storage ${i?.variant} (${i?.plan})`)
});